import { render } from "./cpt-scroll-list.vue?vue&type=template&id=130a1961"
import script from "./cpt-scroll-list.vue?vue&type=script&lang=js"
export * from "./cpt-scroll-list.vue?vue&type=script&lang=js"

import "./cpt-scroll-list.vue?vue&type=style&index=0&id=130a1961&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__